import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M56.52 11.7699C51.11 5.0099 38.8999 1.01001 31.7999 1.01001C24.6999 1.01001 12.3799 5.0099 6.96992 11.7699C-2.72008 23.8799 3.88996 50.5199 3.88996 50.5199C3.88996 50.5199 4.54995 28.9399 11.82 22.5599C18.01 17.1199 23.6899 19.21 31.7499 19.21C39.8099 19.21 45.4899 17.1299 51.6799 22.5599C58.9499 28.9499 59.6099 50.5199 59.6099 50.5199C59.6099 50.5199 66.21 23.8799 56.52 11.7699Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M25.1801 1.58997C25.1801 1.58997 22.7001 7.20001 26.1701 19.26"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M17.5799 4.05994C17.5799 4.05994 13.6199 10.34 16.5899 19.75" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M14.12 5.88C14.12 5.88 8.84 11.33 10.98 22.89"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.63004 11.7699C6.63004 11.7699 1.07005 23.0499 6.02005 34.7799"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M38.3201 1.58997C38.3201 1.58997 40.8001 7.20001 37.3301 19.26"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M45.9102 4.05994C45.9102 4.05994 49.8702 10.34 46.9002 19.75" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M49.3801 5.88C49.3801 5.88 54.6601 11.33 52.5201 22.89"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.8701 11.7699C56.8701 11.7699 62.4301 23.0499 57.4801 34.7799"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
